import { configuratorBuilder } from 'metalworks-domain'

import { createAdminInterface } from '@salsita-ai/platform-project-sdk/admin'

export const adminDomainHooks = createAdminInterface(configuratorBuilder)
